import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import classNames from 'classnames';
import { assetUrl } from '../../../utils/graphqlClient';
import { useAppContext } from '../../../context/AppContext';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || process.env.MAPBOX_TOKEN || '';

const CustomMap = ({ usage, size, zoom, allGpsDatas, id }) => {
  const { state } = useAppContext();
  const gpsData = allGpsDatas || state.allGpsDatas;
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || !Array.isArray(gpsData) || gpsData.length === 0) {
      return undefined;
    }

    let center = [3.488239, 47.169279];

    if (usage === 'one') {
      const selected = gpsData.find((data) => data.id === id);
      const coords = selected?.gps?.coordinates;
      if (Array.isArray(coords) && coords.length === 2) {
        center = coords;
      }
    }

    const map = new mapboxgl.Map({
      container: mapRef.current,
      style: 'mapbox://styles/mikymaxxx/ck8vkf6jt2ekr1ipmqz8jm5lo',
      center,
      zoom,
    });

    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

    const features = gpsData
      .filter((item) => Array.isArray(item?.gps?.coordinates) && item.gps.coordinates.length === 2)
      .map((item) => ({
        geometry: {
          type: 'Point',
          coordinates: item.gps.coordinates,
        },
        img: item.thumb || item.src,
        title: item.place || '',
      }));

    features.forEach((marker) => {
      const popupContainer = document.createElement('div');

      if (usage === 'more' && marker.img) {
        const image = document.createElement('img');
        image.src = assetUrl(`uploads/${marker.img}`);
        image.alt = marker.title || 'Photo';
        popupContainer.appendChild(image);
      }

      const title = document.createElement('h3');
      title.className = 'popup-title';
      title.textContent = marker.title;
      popupContainer.appendChild(title);

      new mapboxgl.Marker({ color: '#F8B739' })
        .setLngLat(marker.geometry.coordinates)
        .setPopup(new mapboxgl.Popup({ offset: 25 }).setDOMContent(popupContainer).setMaxWidth('300px'))
        .addTo(map);
    });

    return () => {
      map.remove();
    };
  }, [gpsData, id, usage, zoom]);

  const mapSizeClassname = classNames('mapContainer', {
    'mapContainer-50': size === 50,
  });

  return (
    <div className="custom-map">
      <div ref={mapRef} className={mapSizeClassname} />
    </div>
  );
};

export default CustomMap;
